<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Einladung senden</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button nlc-button nlc-button-icon-only">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="invitationForm" class="invitation-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>E-Mail-Adresse</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="beispiel@email.de"
          [disabled]="isLoading">
        <mat-icon matPrefix>email</mat-icon>
        <mat-error *ngIf="emailControl?.hasError('required')">
          E-Mail-Adresse ist erforderlich
        </mat-error>
        <mat-error *ngIf="emailControl?.hasError('email')">
          Bitte geben Sie eine gültige E-Mail-Adresse ein
        </mat-error>
        <mat-error *ngIf="emailControl?.hasError('emailExists')">
          Diese E-Mail-Adresse ist bereits registriert
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nachricht</mat-label>
        <textarea
          matInput
          formControlName="message"
          rows="6"
          placeholder="Geben Sie hier Ihre Einladungsnachricht ein..."
          [disabled]="isLoading"
          maxlength="1000"></textarea>
        <mat-icon matPrefix>message</mat-icon>
        <mat-hint align="end">
          {{ messageControl?.value?.length || 0 }}/1000
        </mat-hint>
        <mat-error *ngIf="messageControl?.hasError('required')">
          Nachricht ist erforderlich
        </mat-error>
        <mat-error *ngIf="messageControl?.hasError('maxlength')">
          Die Nachricht darf maximal 1000 Zeichen enthalten
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isLoading">
    Abbrechen
  </button>
  <button style="margin-left: 10px;" (click)="onSend()" [disabled]="isLoading || !invitationForm.valid" [class]="'nlc-button ' + (invitationForm.valid ? 'nlc-button-primary' : '') + ' nlc-button-small'">
    <mat-spinner *ngIf="isLoading" diameter="20" class="button-spinner"></mat-spinner>
    <span *ngIf="!isLoading">
      <mat-icon>send</mat-icon>
      Einladung senden
    </span>
  </button>
</mat-dialog-actions>
</div>